import posthog from 'posthog-js'
posthog.init('phc_iDoBqvReVHMJABCz0cyioCV1AGEsn6qchFdevzYmiSF', { api_host: 'https://data-ph.qrcodesunlimited.com', person_profiles: 'identified_only' })
window.posthog = posthog